import React from "react"
import { Typography, TypographyProps } from "@material-ui/core"

import useContactDisplay from "@/hooks/useContactDisplay"

type ClientNameProps = TypographyProps & {
	name: string
	phone?: string
}

const ClientName: React.FC<ClientNameProps> = (props) => {
	const { className, name, phone, ...rest } = props
	const { getDisplayName } = useContactDisplay()

	const displayName = getDisplayName(name, phone) ?? name

	return (
		<Typography
			variant="caption"
			color="textPrimary"
			{...rest}
			className={`${className}`}
		>
			~{displayName}
		</Typography>
	)
}

export default ClientName
